import { Person } from 'types'

const getPersonName = (profile?: Person) => {
  const str = [profile?.firstName, profile?.lastName].filter(Boolean).join(' ')

  return str || 'Hi there!'
}

export default getPersonName
